import { toggleHamburger } from "./toggleHamburger";
import { accordion } from "./accordion";
import { tabMenu } from "./tabMenu";
toggleHamburger("js-hamburger", "js-spmenu", 1024);
accordion();
tabMenu();

const mvSliderElement = document.querySelector(".js-mv-slider");
if (mvSliderElement) {
  const mvSlider = new Splide(mvSliderElement, {
    breakpoints: {
      768: {},
    },
    type: "fade",
    arrows: false,
    autoplay: true,
    rewind: true,
    focus: "center",
    // autoWidth: true,
    flickMaxPages: 1,
    flickPower: 50,
    pauseOnHover: false,
    pauseOnFocus: false,
  }).mount();
  mvSlider.on("resize", () => {
    mvSlider.refresh();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll("ul.js-member-archive > li");

  gsap.to(items, {
    opacity: 1,
    y: 0,
    visibility: "visible",
    duration: 0.5,
    ease: "power2.out",
    stagger: {
      each: 0.1,
      from: "start",
    },
  });
});
